<script context="module" lang="ts">import 'json-schema';
export function getDisplayName() {
    return "Stats: Matchup Vertical A";
}
export function getElementConfigSpec() {
    return {
        type: "object",
        properties: {
            // General Layout
            padding: { type: "string", title: "Padding", description: "Outer padding of the card." },
            // Header Image
            headerImageUrl: { type: "string", format: "url", title: "Header Image URL", description: "URL for the header image." },
            headerImageAlt: { type: "string", title: "Header Image Alt Text", description: "Alternative text for the header image." },
            headerImageMaxWidth: { type: "string", title: "Header Image Max Width", description: "Maximum width of the header image." },
            headerImageMaxHeight: { type: "string", title: "Header Image Max Height", description: "Maximum height of the header image." },
            // Start Date and Time
            startDateTime: { type: "string", format: "date-time", title: "Start Date and Time", description: "The start date and time of the match." },
            startDateFontColor: { type: "string", title: "Start Date Font Color", description: "Font color for the start date." },
            startDateFontSize: { type: "string", title: "Start Date Font Size", description: "Font size for the start date." },
            startDateFontWeight: { type: "string", title: "Start Date Font Weight", description: "Font weight for the start date." },
            // Location
            locationText: { type: "string", title: "Location Text", description: "Text for the match location." },
            locationFontColor: { type: "string", title: "Location Font Color", description: "Font color for the location text." },
            locationFontSize: { type: "string", title: "Location Font Size", description: "Font size for the location text." },
            locationFontWeight: { type: "string", title: "Location Font Weight", description: "Font weight for the location text." },
            // Team Details
            leftTeamText: { type: "string", title: "Left Team Text", description: "Text for the left team." },
            leftTeamFontColor: { type: "string", title: "Left Team Font Color", description: "Font color for the left team text." },
            leftTeamFontSize: { type: "string", title: "Left Team Font Size", description: "Font size for the left team text." },
            leftTeamFontWeight: { type: "string", title: "Left Team Font Weight", description: "Font weight for the left team text." },
            leftTeamImageUrl: { type: "string", format: "url", title: "Left Team Image URL", description: "URL for the left team image." },
            leftTeamImageAlt: { type: "string", title: "Left Team Image Alt", description: "Alternative text for the left team image." },
            leftTeamImageMaxWidth: { type: "string", title: "Left Team Image Max Width", description: "Maximum width for the left team image." },
            leftTeamImageMaxHeight: { type: "string", title: "Left Team Image Max Height", description: "Maximum height for the left team image." },
            rightTeamText: { type: "string", title: "Right Team Text", description: "Text for the right team." },
            rightTeamFontColor: { type: "string", title: "Right Team Font Color", description: "Font color for the right team text." },
            rightTeamFontSize: { type: "string", title: "Right Team Font Size", description: "Font size for the right team text." },
            rightTeamFontWeight: { type: "string", title: "Right Team Font Weight", description: "Font weight for the right team text." },
            rightTeamImageUrl: { type: "string", format: "url", title: "Right Team Image URL", description: "URL for the right team image." },
            rightTeamImageAlt: { type: "string", title: "Right Team Image Alt", description: "Alternative text for the right team image." },
            rightTeamImageMaxWidth: { type: "string", title: "Right Team Image Max Width", description: "Maximum width for the right team image." },
            rightTeamImageMaxHeight: { type: "string", title: "Right Team Image Max Height", description: "Maximum height for the right team image." },
            // Bottom Button
            bottomButtonText: { type: "string", title: "Bottom Button Text", description: "Text for the bottom button." },
            bottomButtonBackgroundColor: { type: "string", title: "Bottom Button Background Color", description: "Background color for the bottom button." },
            bottomButtonFontColor: { type: "string", title: "Bottom Button Font Color", description: "Font color for the bottom button text." },
            bottomButtonFontSize: { type: "string", title: "Bottom Button Font Size", description: "Font size for the bottom button text." },
            bottomButtonFontWeight: { type: "string", title: "Bottom Button Font Weight", description: "Font weight for the bottom button text." },
            bottomButtonBorderSize: { type: "string", title: "Bottom Button Border Size", description: "Border size for the bottom button." },
            bottomButtonBorderStyle: { type: "string", title: "Bottom Button Border Style", description: "Border style for the bottom button." },
            bottomButtonBorderColor: { type: "string", title: "Bottom Button Border Color", description: "Border color for the bottom button." },
            bottomButtonBorderRadius: { type: "string", title: "Bottom Button Border Radius", description: "Border radius for the bottom button." },
            bottomButtonBoxShadowOffsetX: { type: "string", title: "Bottom Button Box Shadow Offset X", description: "Horizontal offset for the bottom button box shadow." },
            bottomButtonBoxShadowOffsetY: { type: "string", title: "Bottom Button Box Shadow Offset Y", description: "Vertical offset for the bottom button box shadow." },
            bottomButtonBoxShadowBlurRadius: { type: "string", title: "Bottom Button Box Shadow Blur Radius", description: "Blur radius for the bottom button box shadow." },
            bottomButtonBoxShadowSpreadRadius: { type: "string", title: "Bottom Button Box Shadow Spread Radius", description: "Spread radius for the bottom button box shadow." },
            bottomButtonBoxShadowColor: { type: "string", title: "Bottom Button Box Shadow Color", description: "Color for the bottom button box shadow." },
            // Bottom Button Hover Styles
            bottomButtonHoverBackgroundColor: {
                type: "string",
                title: "Bottom Button Hover Background Color",
                description: "Background color for the bottom button on hover."
            },
            bottomButtonHoverFontColor: {
                type: "string",
                title: "Bottom Button Hover Font Color",
                description: "Font color for the bottom button text on hover."
            },
            bottomButtonHoverFontSize: {
                type: "string",
                title: "Bottom Button Hover Font Size",
                description: "Font size for the bottom button text on hover."
            },
            bottomButtonHoverFontWeight: {
                type: "string",
                title: "Bottom Button Hover Font Weight",
                description: "Font weight for the bottom button text on hover."
            },
            bottomButtonHoverBorderSize: {
                type: "string",
                title: "Bottom Button Hover Border Size",
                description: "Border size for the bottom button on hover."
            },
            bottomButtonHoverBorderStyle: {
                type: "string",
                title: "Bottom Button Hover Border Style",
                description: "Border style for the bottom button on hover."
            },
            bottomButtonHoverBorderColor: {
                type: "string",
                title: "Bottom Button Hover Border Color",
                description: "Border color for the bottom button on hover."
            },
            bottomButtonHoverBorderRadius: {
                type: "string",
                title: "Bottom Button Hover Border Radius",
                description: "Border radius for the bottom button on hover."
            },
            bottomButtonHoverBoxShadowOffsetX: {
                type: "string",
                title: "Bottom Button Hover Box Shadow Offset X",
                description: "Horizontal offset for the bottom button box shadow on hover."
            },
            bottomButtonHoverBoxShadowOffsetY: {
                type: "string",
                title: "Bottom Button Hover Box Shadow Offset Y",
                description: "Vertical offset for the bottom button box shadow on hover."
            },
            bottomButtonHoverBoxShadowBlurRadius: {
                type: "string",
                title: "Bottom Button Hover Box Shadow Blur Radius",
                description: "Blur radius for the bottom button box shadow on hover."
            },
            bottomButtonHoverBoxShadowSpreadRadius: {
                type: "string",
                title: "Bottom Button Hover Box Shadow Spread Radius",
                description: "Spread radius for the bottom button box shadow on hover."
            },
            bottomButtonHoverBoxShadowColor: {
                type: "string",
                title: "Bottom Button Hover Box Shadow Color",
                description: "Color for the bottom button box shadow on hover."
            }
        }
    };
}
export function getElementDataSourceSpec() {
    return {
        sources: [
            {
                type: 'SOURCE',
                title: 'Card Data',
                description: 'Arbitrary source of data for this card matching the configuration fields.',
                classes: '*'
            }
        ]
    };
}
</script>

<script lang="ts">import "yinzcam-cards";
import CardBase from "components/cards/common/CardBase.svelte";
import { getFirstSourceStore, getTemplatedElementDataFromSource, buildInlineStyle, formatDateTimeLocal } from "components/cards/utilities";
import "svelte/store";
import 'components/cards/common/CardsElementInterfaces';
export let element;
export let sources;
export let sourceStore;
$: sourceStore = getFirstSourceStore($sources);
$: padding = getTemplatedElementDataFromSource(element, "padding", $sourceStore);
$: headerImageUrl = getTemplatedElementDataFromSource(element, "headerImageUrl", $sourceStore);
$: headerImageAlt = getTemplatedElementDataFromSource(element, "headerImageAlt", $sourceStore);
$: headerImageMaxWidth = getTemplatedElementDataFromSource(element, "headerImageMaxWidth", $sourceStore);
$: headerImageMaxHeight = getTemplatedElementDataFromSource(element, "headerImageMaxHeight", $sourceStore);
$: startDateTime = getTemplatedElementDataFromSource(element, "startDateTime", $sourceStore);
$: startDateFontColor = getTemplatedElementDataFromSource(element, "startDateFontColor", $sourceStore);
$: startDateFontSize = getTemplatedElementDataFromSource(element, "startDateFontSize", $sourceStore);
$: startDateFontWeight = getTemplatedElementDataFromSource(element, "startDateFontWeight", $sourceStore);
$: locationText = getTemplatedElementDataFromSource(element, "locationText", $sourceStore);
$: locationFontColor = getTemplatedElementDataFromSource(element, "locationFontColor", $sourceStore);
$: locationFontSize = getTemplatedElementDataFromSource(element, "locationFontSize", $sourceStore);
$: locationFontWeight = getTemplatedElementDataFromSource(element, "locationFontWeight", $sourceStore);
$: startTimePrefixText = getTemplatedElementDataFromSource(element, "startTimePrefixText", $sourceStore);
$: startTimePrefixFontColor = getTemplatedElementDataFromSource(element, "startTimePrefixFontColor", $sourceStore);
$: startTimePrefixFontSize = getTemplatedElementDataFromSource(element, "startTimePrefixFontSize", $sourceStore);
$: startTimePrefixFontWeight = getTemplatedElementDataFromSource(element, "startTimePrefixFontWeight", $sourceStore);
$: startTimeZone = getTemplatedElementDataFromSource(element, "startTimeZone", $sourceStore);
$: startTimeFontColor = getTemplatedElementDataFromSource(element, "startTimeFontColor", $sourceStore);
$: startTimeFontSize = getTemplatedElementDataFromSource(element, "startTimeFontSize", $sourceStore);
$: startTimeFontWeight = getTemplatedElementDataFromSource(element, "startTimeFontWeight", $sourceStore);
$: leftTeamNameText = getTemplatedElementDataFromSource(element, "leftTeamNameText", $sourceStore);
$: leftTeamNameFontColor = getTemplatedElementDataFromSource(element, "leftTeamNameFontColor", $sourceStore);
$: leftTeamNameFontSize = getTemplatedElementDataFromSource(element, "leftTeamNameFontSize", $sourceStore);
$: leftTeamNameFontWeight = getTemplatedElementDataFromSource(element, "leftTeamNameFontWeight", $sourceStore);
$: leftTeamImageUrl = getTemplatedElementDataFromSource(element, "leftTeamImageUrl", $sourceStore);
$: leftTeamImageAlt = getTemplatedElementDataFromSource(element, "leftTeamImageAlt", $sourceStore);
$: leftTeamImageMaxWidth = getTemplatedElementDataFromSource(element, "leftTeamImageMaxWidth", $sourceStore);
$: leftTeamImageMaxHeight = getTemplatedElementDataFromSource(element, "leftTeamImageMaxHeight", $sourceStore);
$: matchState = getTemplatedElementDataFromSource(element, "matchState", $sourceStore) || 'PRE'; // PRE, LIVE, POST
$: preMatchTimeBackgroundTopColor = getTemplatedElementDataFromSource(element, "preMatchTimeBackgroundTopColor", $sourceStore);
$: preMatchTimeBackgroundBottomColor = getTemplatedElementDataFromSource(element, "preMatchTimeBackgroundBottomColor", $sourceStore);
$: preMatchTimeBorderWidth = getTemplatedElementDataFromSource(element, "preMatchTimeBorderWidth", $sourceStore);
$: preMatchTimeBorderStyle = getTemplatedElementDataFromSource(element, "preMatchTimeBorderStyle", $sourceStore);
$: preMatchTimeBorderColor = getTemplatedElementDataFromSource(element, "preMatchTimeBorderColor", $sourceStore);
$: preMatchTimeBorderRadius = getTemplatedElementDataFromSource(element, "preMatchTimeBorderRadius", $sourceStore);
$: preMatchTimePrefixText = getTemplatedElementDataFromSource(element, "preMatchTimePrefixText", $sourceStore);
$: preMatchTimePrefixFontColor = getTemplatedElementDataFromSource(element, "preMatchTimePrefixFontColor", $sourceStore);
$: preMatchTimePrefixFontSize = getTemplatedElementDataFromSource(element, "preMatchTimePrefixFontSize", $sourceStore);
$: preMatchTimePrefixFontWeight = getTemplatedElementDataFromSource(element, "preMatchTimePrefixFontWeight", $sourceStore);
$: preMatchTimeFontColor = getTemplatedElementDataFromSource(element, "preMatchTimeFontColor", $sourceStore);
$: preMatchTimeFontSize = getTemplatedElementDataFromSource(element, "preMatchTimeFontSize", $sourceStore);
$: preMatchTimeFontWeight = getTemplatedElementDataFromSource(element, "preMatchTimeFontWeight", $sourceStore);
$: liveMatchScoreBackgroundTopColor = getTemplatedElementDataFromSource(element, "liveMatchScoreBackgroundTopColor", $sourceStore);
$: liveMatchScoreBackgroundBottomColor = getTemplatedElementDataFromSource(element, "liveMatchScoreBackgroundBottomColor", $sourceStore);
$: liveMatchScoreBorderWidth = getTemplatedElementDataFromSource(element, "liveMatchScoreBorderWidth", $sourceStore);
$: liveMatchScoreBorderStyle = getTemplatedElementDataFromSource(element, "liveMatchScoreBorderStyle", $sourceStore);
$: liveMatchScoreBorderColor = getTemplatedElementDataFromSource(element, "liveMatchScoreBorderColor", $sourceStore);
$: liveMatchScoreBorderRadius = getTemplatedElementDataFromSource(element, "liveMatchScoreBorderRadius", $sourceStore);
$: liveMatchLeftTeamScore = getTemplatedElementDataFromSource(element, "liveMatchLeftTeamScore", $sourceStore);
$: liveMatchLeftTeamScoreFontColor = getTemplatedElementDataFromSource(element, "liveMatchLeftTeamScoreFontColor", $sourceStore);
$: liveMatchLeftTeamScoreFontSize = getTemplatedElementDataFromSource(element, "liveMatchLeftTeamScoreFontSize", $sourceStore);
$: liveMatchLeftTeamScoreFontWeight = getTemplatedElementDataFromSource(element, "liveMatchLeftTeamScoreFontWeight", $sourceStore);
$: liveMatchRightTeamScore = getTemplatedElementDataFromSource(element, "liveMatchRightTeamScore", $sourceStore);
$: liveMatchRightTeamScoreFontColor = getTemplatedElementDataFromSource(element, "liveMatchRightTeamScoreFontColor", $sourceStore);
$: liveMatchRightTeamScoreFontSize = getTemplatedElementDataFromSource(element, "liveMatchRightTeamScoreFontSize", $sourceStore);
$: liveMatchRightTeamScoreFontWeight = getTemplatedElementDataFromSource(element, "liveMatchRightTeamScoreFontWeight", $sourceStore);
$: rightTeamNameText = getTemplatedElementDataFromSource(element, "rightTeamNameText", $sourceStore);
$: rightTeamNameFontColor = getTemplatedElementDataFromSource(element, "rightTeamNameFontColor", $sourceStore);
$: rightTeamNameFontSize = getTemplatedElementDataFromSource(element, "rightTeamNameFontSize", $sourceStore);
$: rightTeamNameFontWeight = getTemplatedElementDataFromSource(element, "rightTeamNameFontWeight", $sourceStore);
$: rightTeamImageUrl = getTemplatedElementDataFromSource(element, "rightTeamImageUrl", $sourceStore);
$: rightTeamImageAlt = getTemplatedElementDataFromSource(element, "rightTeamImageAlt", $sourceStore);
$: rightTeamImageMaxWidth = getTemplatedElementDataFromSource(element, "rightTeamImageMaxWidth", $sourceStore);
$: rightTeamImageMaxHeight = getTemplatedElementDataFromSource(element, "rightTeamImageMaxHeight", $sourceStore);
$: bottomButtonText = getTemplatedElementDataFromSource(element, "bottomButtonText", $sourceStore);
$: bottomButtonLinkUrl = getTemplatedElementDataFromSource(element, "bottomButtonLinkUrl", $sourceStore);
$: bottomButtonBackgroundColor = getTemplatedElementDataFromSource(element, "bottomButtonBackgroundColor", $sourceStore);
$: bottomButtonFontColor = getTemplatedElementDataFromSource(element, "bottomButtonFontColor", $sourceStore);
$: bottomButtonFontSize = getTemplatedElementDataFromSource(element, "bottomButtonFontSize", $sourceStore);
$: bottomButtonFontWeight = getTemplatedElementDataFromSource(element, "bottomButtonFontWeight", $sourceStore);
$: bottomButtonBorderWidth = getTemplatedElementDataFromSource(element, "bottomButtonBorderWidth", $sourceStore);
$: bottomButtonBorderStyle = getTemplatedElementDataFromSource(element, "bottomButtonBorderStyle", $sourceStore);
$: bottomButtonBorderColor = getTemplatedElementDataFromSource(element, "bottomButtonBorderColor", $sourceStore);
$: bottomButtonBorderRadius = getTemplatedElementDataFromSource(element, "bottomButtonBorderRadius", $sourceStore);
$: bottomButtonBoxShadowOffsetX = getTemplatedElementDataFromSource(element, "bottomButtonBoxShadowOffsetX", $sourceStore);
$: bottomButtonBoxShadowOffsetY = getTemplatedElementDataFromSource(element, "bottomButtonBoxShadowOffsetY", $sourceStore);
$: bottomButtonBoxShadowBlurRadius = getTemplatedElementDataFromSource(element, "bottomButtonBoxShadowBlurRadius", $sourceStore);
$: bottomButtonBoxShadowSpreadRadius = getTemplatedElementDataFromSource(element, "bottomButtonBoxShadowSpreadRadius", $sourceStore);
$: bottomButtonBoxShadowColor = getTemplatedElementDataFromSource(element, "bottomButtonBoxShadowColor", $sourceStore);
$: bottomButtonHoverBackgroundColor = getTemplatedElementDataFromSource(element, "bottomButtonHoverBackgroundColor", $sourceStore);
$: bottomButtonHoverFontColor = getTemplatedElementDataFromSource(element, "bottomButtonHoverFontColor", $sourceStore);
$: bottomButtonHoverFontSize = getTemplatedElementDataFromSource(element, "bottomButtonHoverFontSize", $sourceStore);
$: bottomButtonHoverFontWeight = getTemplatedElementDataFromSource(element, "bottomButtonHoverFontWeight", $sourceStore);
$: bottomButtonHoverBorderColor = getTemplatedElementDataFromSource(element, "bottomButtonHoverBorderColor", $sourceStore);
$: startDateDisplay = formatDateTimeLocal(startDateTime, { weekday: 'long', 'month': 'long', 'day': 'numeric' });
$: startTimeLocalDisplay = formatDateTimeLocal(startDateTime, { timeStyle: 'short' });
$: startTimeZoneDisplay = formatDateTimeLocal(startDateTime, { timeStyle: 'short', timeZone: startTimeZone });
$: style = buildInlineStyle("padding", padding, "header-image-url", headerImageUrl, // Note: This won't directly apply to inline styles and needs to be handled separately
"header-image-max-width", headerImageMaxWidth, "header-image-max-height", headerImageMaxHeight, "start-date-font-color", startDateFontColor, "start-date-font-size", startDateFontSize, "start-date-font-weight", startDateFontWeight, "location-font-color", locationFontColor, "location-font-size", locationFontSize, "location-font-weight", locationFontWeight, "start-time-prefix-font-color", startTimePrefixFontColor, "start-time-prefix-font-size", startTimePrefixFontSize, "start-time-prefix-font-weight", startTimePrefixFontWeight, "start-time-font-color", startTimeFontColor, "start-time-font-size", startTimeFontSize, "start-time-font-weight", startTimeFontWeight, "left-team-name-font-color", leftTeamNameFontColor, "left-team-name-font-size", leftTeamNameFontSize, "left-team-name-font-weight", leftTeamNameFontWeight, "left-team-image-max-width", leftTeamImageMaxWidth, "left-team-image-max-height", leftTeamImageMaxHeight, "pre-match-time-background-top-color", preMatchTimeBackgroundTopColor, "pre-match-time-background-bottom-color", preMatchTimeBackgroundBottomColor, "pre-match-time-border-width", preMatchTimeBorderWidth, "pre-match-time-border-style", preMatchTimeBorderStyle, "pre-match-time-border-color", preMatchTimeBorderColor, "pre-match-time-border-radius", preMatchTimeBorderRadius, "pre-match-time-prefix-font-color", preMatchTimePrefixFontColor, "pre-match-time-prefix-font-size", preMatchTimePrefixFontSize, "pre-match-time-prefix-font-weight", preMatchTimePrefixFontWeight, "pre-match-time-font-color", preMatchTimeFontColor, "pre-match-time-font-size", preMatchTimeFontSize, "pre-match-time-font-weight", preMatchTimeFontWeight, "live-match-score-background-top-color", liveMatchScoreBackgroundTopColor, "live-match-score-background-bottom-color", liveMatchScoreBackgroundBottomColor, "live-match-score-border-width", liveMatchScoreBorderWidth, "live-match-score-border-style", liveMatchScoreBorderStyle, "live-match-score-border-color", liveMatchScoreBorderColor, "live-match-score-border-radius", liveMatchScoreBorderRadius, "live-match-left-team-score-font-color", liveMatchLeftTeamScoreFontColor, "live-match-left-team-score-font-size", liveMatchLeftTeamScoreFontSize, "live-match-left-team-score-font-weight", liveMatchLeftTeamScoreFontWeight, "live-match-right-team-score-font-color", liveMatchRightTeamScoreFontColor, "live-match-right-team-score-font-size", liveMatchRightTeamScoreFontSize, "live-match-right-team-score-font-weight", liveMatchRightTeamScoreFontWeight, "right-team-name-font-color", rightTeamNameFontColor, "right-team-name-font-size", rightTeamNameFontSize, "right-team-name-font-weight", rightTeamNameFontWeight, "right-team-image-max-width", rightTeamImageMaxWidth, "right-team-image-max-height", rightTeamImageMaxHeight, "bottom-button-background-color", bottomButtonBackgroundColor, "bottom-button-font-color", bottomButtonFontColor, "bottom-button-font-size", bottomButtonFontSize, "bottom-button-font-weight", bottomButtonFontWeight, "bottom-button-border-size", bottomButtonBorderWidth, "bottom-button-border-style", bottomButtonBorderStyle, "bottom-button-border-color", bottomButtonBorderColor, "bottom-button-border-radius", bottomButtonBorderRadius, "bottom-button-box-shadow-offset-x", bottomButtonBoxShadowOffsetX, "bottom-button-box-shadow-offset-y", bottomButtonBoxShadowOffsetY, "bottom-button-box-shadow-blur-radius", bottomButtonBoxShadowBlurRadius, "bottom-button-box-shadow-spread-radius", bottomButtonBoxShadowSpreadRadius, "bottom-button-box-shadow-color", bottomButtonBoxShadowColor, "bottom-button-hover-background-color", bottomButtonHoverBackgroundColor, "bottom-button-hover-font-color", bottomButtonHoverFontColor, "bottom-button-hover-font-size", bottomButtonHoverFontSize, "bottom-button-hover-font-weight", bottomButtonHoverFontWeight, "bottom-button-hover-border-color", bottomButtonHoverBorderColor);
</script>
  
  <CardBase {element}>
    <div class="vertical-match" {style}>
      <div class="header-image">
        <img src={headerImageUrl} alt={headerImageAlt}>
      </div>
      <div>
        <div class="start-date-text">
          {startDateDisplay}
        </div>
        <div class="location-text">
          {locationText}
        </div>
      </div>
      <div>
        <div class="start-time-prefix-text">
          {#if matchState === 'PRE'}
            {startTimePrefixText}
          {:else}
            &nbsp;
          {/if}
        </div>
        <div class="start-time-text">
          {#if matchState === 'PRE'}
            {startTimeZoneDisplay}
          {:else}
            &nbsp;
          {/if}
        </div>
      </div>
      <div>
        <div class="left-team-name">
          {leftTeamNameText}
        </div>
        <div class="left-team-image">
          <img src={leftTeamImageUrl} alt={leftTeamImageAlt}>
        </div>
        <div class="score-board">
        {#if matchState === 'PRE'}
          <span class="pre-match-time">
            <span class="pre-match-time-prefix">{preMatchTimePrefixText}</span>
            <span class="pre-match-time-text">{startTimeLocalDisplay}</span>
          </span>
        {:else}
          <span class="live-match-left-team-score">
            {liveMatchLeftTeamScore}
          </span>
          <span class="live-match-right-team-score">
            {liveMatchRightTeamScore}
          </span>
        {/if}
        </div>
        <div class="right-team-image">
          <img src={rightTeamImageUrl} alt={rightTeamImageAlt}>
        </div>
        <div class="right-team-name">
          {rightTeamNameText}
        </div>
      </div>
        <a href={bottomButtonLinkUrl} class="bottom-button">
            <span class="icon"><svg class="ball-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73 73"><path d="M29.28 67.35L25.26 55a1.2 1.2 0 00-1.14-.83H10.17a31.5 31.5 0 01-5.28-15.76l10-7a1.19 1.19 0 00.46-1.35l-4.09-12.67A31.87 31.87 0 0124.47 7.18l11.34 8.23a1.2 1.2 0 00.7.23 1.17 1.17 0 00.7-.23l11.34-8.23a31.84 31.84 0 0113.57 10.7l-4 12.19a1.2 1.2 0 00.36 1.28l9.55 8.23a31.49 31.49 0 01-5.21 14.55L51 54.15a1.19 1.19 0 00-1.12.79l-4.37 12a31.12 31.12 0 01-16.23.46zM36.5 0a36.49 36.49 0 00-7.94 72.1 1.19 1.19 0 00.7.23h.18A36.5 36.5 0 1036.5 0z"></path><path d="M45.94 50.62l5.13-15.78a1.2 1.2 0 00-.43-1.34l-13.43-9.75a1.2 1.2 0 00-1.41 0L22.38 33.5a1.19 1.19 0 00-.43 1.34l5.13 15.78a1.2 1.2 0 001.14.83H44.8a1.2 1.2 0 001.14-.83z"></path></svg></span>
            <span class="text">{bottomButtonText}</span>
        </a>
    </div>
  </CardBase>
  
  <style>
    *, *::before, *::after {
      box-sizing: border-box;
    }

    .vertical-match {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: var(--padding, 20px);
      gap: 10px;
    }

    .header-image img {
      max-width: var(--header-image-max-width, 80%);
      max-height: var(--header-image-max-height, 4.5em);
    }

    .start-date-text {
      color: var(--start-date-font-color, unset);
      font-size: var(--start-date-font-size, unset);
      font-weight: var(--start-date-font-weight, 800);
    }

    .location-text {
      color: var(--location-font-color, unset);
      font-size: var(--location-font-size, unset);
      font-weight: var(--location-font-weight, unset);
    }

    .start-time-prefix-text {
      color: var(--start-time-prefix-font-color, unset);
      font-size: var(--start-time-prefix-font-size, unset);
      font-weight: var(--start-time-prefix-font-weight, 600);
    }

    .start-time-text {
      color: var(--start-time-font-color, unset);
      font-size: var(--start-time-font-size, unset);
      font-weight: var(--start-time-font-weight, unset);
    }

    .left-team-name {
      color: var(--left-team-name-font-color, unset);
      font-size: var(--left-team-name-font-size, 1.2em);
      font-weight: var(--left-team-name-font-weight, 800);
    }

    .left-team-image img {
      max-width: var(--left-team-image-max-width, 4em);
      max-height: var(--left-team-image-max-height, 4em);
    }

    .pre-match-time {
      background: linear-gradient(to bottom, var(--pre-match-time-background-top-color, #f7f7f7), var(--pre-match-time-background-bottom-color, #ebebeb) 50%, var(--pre-match-time-background-top-color, #f7f7f7) 50%);
      border: var(--pre-match-time-border-width, 1px) var(--pre-match-time-border-style, solid) var(--pre-match-time-border-color, #f7f7f7);
      border-radius: var(--pre-match-time-border-radius, unset);
    }

    .pre-match-time-prefix {
      color: var(--pre-match-time-prefix-font-color, unset);
      font-size: var(--pre-match-time-prefix-font-size, unset);
      font-weight: var(--pre-match-time-prefix-font-weight, 600);
    }

    .pre-match-time-text {
      color: var(--pre-match-time-text-font-color, unset);
      font-size: var(--pre-match-time-text-font-size, unset);
      font-weight: var(--pre-match-time-text-font-weight, unset);
    }

    .live-match-left-team-score, .live-match-right-team-score {
      background: linear-gradient(to bottom, var(--live-match-score-background-top-color, #08192a), var(--live-match-score-background-bottom-color, #31404f) 50%, var(--live-match-score-background-top-color, #08192a) 50%);
      border: var(--live-match-score-border-width, 1px) var(--live-match-score-border-style, solid) var(--live-match-score-border-color, #061729);
      border-radius: var(--live-match-score-border-radius, unset);
    }

    .live-match-left-team-score {
      color: var(--live-match-left-team-score-font-color, white);
      font-size: var(--live-match-left-team-score-font-size, 1.5em);
      font-weight: var(--live-match-left-team-score-font-weight, unset);
    }

    .live-match-right-team-score {
      color: var(--live-match-right-team-score-font-color, white);
      font-size: var(--live-match-right-team-score-font-size, 1.5em);
      font-weight: var(--live-match-right-team-score-font-weight, unset);
    }

    .right-team-name {
      color: var(--right-team-name-font-color, unset);
      font-size: var(--right-team-name-font-size, 1.2em);
      font-weight: var(--right-team-name-font-weight, 800);
    }

    .right-team-image img {
      max-width: var(--right-team-image-max-width, 4em);
      max-height: var(--right-team-image-max-height, 4em);
    }

    .vertical-match div {
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 5px;
    }

    .bottom-button {
      margin-top: 1em;
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 10px;
      padding: 10px 30px;
      max-width: 100%;
      background-color: var(--bottom-button-background-color, unset);
      color: var(--bottom-button-font-color, unset);
      font-size: var(--bottom-button-font-size, unset);
      font-weight: var(--bottom-button-font-weight, unset);
      border: var(--bottom-button-border-width, 1px) var(--bottom-button-border-style, solid) var(--bottom-button-border-color, transparent);
      border-radius: var(--bottom-button-border-radius, unset);
      box-shadow: var(--bottom-button-box-shadow-offset-y, 0px) var(--bottom-button-box-shadow-offset-x, 2px) var(--bottom-button-box-shadow-blur-radius, 7px) var(--bottom-button-box-shadow-spread-radius, 0px) var(--bottom-button-box-shadow-color, rgba(0, 0, 0, .15));
    }

    .bottom-button .icon {
      flex-grow: 0;
      flex-shrink: 0;
      width: var(--bottom-button-font-size, 1.0em);
      display: flex;
      align-items: center;
    }

    .bottom-button .text {
      flex-grow: 1;
    }

    .bottom-button:hover {
      background-color: var(--bottom-button-hover-background-color, var(--bottom-button-background-color, unset));
      color: var(--bottom-button-hover-font-color, var(--bottom-button-font-color, unset));
      font-size: var(--bottom-button-hover-font-size, var(--bottom-button-font-size, unset));
      font-weight: var(--bottom-button-hover-font-weight, var(--bottom-button-font-weight, unset));
      border-color: var(--bottom-button-hover-border-color, var(--bottom-button-border-color, transparent));
    }

    .score-board {
      gap: 0px !important;
    }

    .score-board span {
      padding: 0.2em 0.6em;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .ball-icon {
      font-size: 1.2em;
      fill: currentColor;
    }</style>
  